<template>
  <div class="checkbox-list">
    <label
      class="checkbox-item"
      v-for="option in options"
      :key="option.value"
      :class="{ 'selected': isSelected(option.value) }"
    >
      <input
        type="checkbox"
        :checked="isSelected(option.value)"
        @change="toggleOption(option)"
        class="custom-checkbox"
      />
      <span class="checkmark"></span>
      <span class="label">{{ option.label }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'CheckboxList',
  props: {
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedValues: []
    }
  },
  watch: {
    modelValue(newValue) {
      this.selectedValues = [...newValue]
    }
  },
  methods: {
    isSelected(value) {
      return this.selectedValues.includes(value)
    },
    toggleOption(option) {
      const index = this.selectedValues.indexOf(option.value)
      if (index === -1) {
        this.selectedValues.push(option.value)
      } else {
        this.selectedValues.splice(index, 1)
      }
      this.$emit('update:modelValue', [...this.selectedValues])
    }
  },
  mounted() {
    this.selectedValues = [...this.modelValue]
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/_shared.scss";
.checkbox-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-family: Arial, sans-serif;
}

.checkbox-item {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;
  background-color: black;
  transition: background-color 0.2s;
}

.checkbox-item:hover {
  background-color: $crow-black;
}

.checkbox-item.selected {
  background-color: $crow-black;
}

.custom-checkbox {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.checkmark {
  width: 16px;
  height: 16px;
  border: 2px solid #666;
  border-radius: 3px;
  margin-right: 10px;
  position: relative;
}

.checkbox-item.selected .checkmark::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 2px;
  width: 5px;
  height: 8px;
  border: solid #007bff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.label {
  flex: 1;
}
</style>